import { useEffect, useRef, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import LatinicaWarningModal from "../../evidencije/LatinicaWarningModal";
import { useGlobalContext } from "../../../../../Context/Context";
import CustomSelectSimple from "../../evidencije/CustomSelectSimple";
import axios from "axios";
import parseBullets from "../../../../utils/parseBullets";

const riziciAll = ["DA", "NE", "NEDEFINISANO"];

const styles = {
  button: {
    padding: "10px 20px"
  }
};

const EditRiziciModal = ({
  handleConfirm,
  handleCancel,
  initialData,
  onRefresh
}) => {
  const [newData, setNewData] = useState();
  const [openLatinicaModal, setOpenLatinicaModal] = useState(false);

  const ref = useRef();
  const { dictionary, baseUrl } = useGlobalContext();

  useEffect(() => {
    if (initialData) setNewData(initialData);
  }, [initialData]);

  const handleChange = (newValue, field) => {
    setNewData((prev) => ({ ...prev, [field]: parseBullets(newValue) }));
  };

  const handleKeyDown = (e) => {
    const key = e.key;
    if (/^[A-Za-z]$/.test(key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }
    if (e.key === "Enter") {
      e.preventDefault();
      const textarea = ref.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const before = newData.rizici.substring(0, start);
      const after = newData.rizici.substring(end);
      const newValue = before + "\n- " + after;
      setNewData((prev) => ({ ...prev, rizici: newValue }));

      requestAnimationFrame(() => {
        const pos = start + 3;
        textarea.setSelectionRange(pos, pos);
      });
    }
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/workplaces/update_rizici.php`,
        {
          workplace_id: newData.id,
          stepen_rizika: newData.rizik,
          rizici: newData.rizici
        }
      );
      if (data.status === 200) {
        handleConfirm(newData);
        if (onRefresh) onRefresh();
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handleCancelLatinica = () => setOpenLatinicaModal(false);

  if (!newData) return;

  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "60%",
          borderRadius: "10px",
          padding: "20px"
        }}
      >
        <CustomSelectSimple
          label={dictionary["povecaniRizik"]}
          allValues={riziciAll}
          selectedValue={newData.rizik}
          onSelectChange={(newValue) => handleChange(newValue, "rizik")}
        />

        <textarea
          ref={ref}
          value={newData.rizici}
          onChange={(e) => handleChange(e.target.value, "rizici")}
          onKeyDown={handleKeyDown}
          rows={30}
          style={{
            width: "100%",
            padding: "10px",
            fontSize: "14px",
            marginTop: "15px"
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px"
          }}
        >
          <div onClick={handleCancel} style={{ width: "10vw", height: "40px" }}>
            <Button activation={true} style={styles.button}>
              <span style={{ fontWeight: "bold" }}>
                {dictionary["odustani"]}
              </span>
            </Button>
          </div>
          <div
            onClick={handleSacuvaj}
            style={{ width: "10vw", height: "40px" }}
          >
            <Button activation={true} style={styles.button}>
              <span style={{ fontWeight: "bold" }}>
                {dictionary["sacuvaj"]}
              </span>
            </Button>
          </div>
        </div>
      </div>
      {openLatinicaModal && (
        <LatinicaWarningModal handleCancel={handleCancelLatinica} />
      )}
    </div>
  );
};

export default EditRiziciModal;
